import React from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Typography,
  VertButton,
  VertContainer,
  VertModal,
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import * as yup from 'yup';

const ModalApprove = ({
  isVisible,
  submitApprove,
  quote = null,
  setIsVisible,
}) => {
  const [form] = Form.useForm();

  const schema = yup.object().shape({
    description: yup.string().required('Comentário é obrigatório'),
  });

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  const handleSubmit = (values) => {
    submitApprove({ shouldApprove: true, description: values.description });
  };

  return (
    <VertModal
      title="Aprovar Solicitação"
      open={isVisible}
      onCancel={() => {
        setIsVisible(false);
        form.resetFields();
      }}
      footer={
        <Row justify="space-between">
          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              className="button-view-redemption"
              onClick={() => {
                setIsVisible(false);
                form.resetFields();
              }}
            >
              CANCELAR
            </VertButton>
          </Col>

          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              type="highlight"
              className="button-view-redemption"
              htmlType="submit"
              form="vert-modal-aprove-spot__form"
            >
              SIM
            </VertButton>
          </Col>
        </Row>
      }
    >
      <VertContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography.Text>
            Certeza que deseja{' '}
            <Typography.Text strong> aprovar</Typography.Text> essa solicitação?
          </Typography.Text>

          {quote !== null ? (
            <Typography.Text>
              Ao clicar em
              <Typography.Text
                strong
                style={{
                  margin: '0 5px',
                }}
              >
                SIM
              </Typography.Text>
              você aprovará a solicitação de orçamento do fornecedor
              <Typography.Text
                strong
                style={{
                  marginLeft: '5px',
                }}
              >
                "{quote.supplier.companyName}"
              </Typography.Text>
              .
            </Typography.Text>
          ) : (
            <Typography.Text>
              {' '}
              Ao clicar em <Typography.Text strong>SIM</Typography.Text> você
              aprovará esta solicitação.
            </Typography.Text>
          )}

          <Form
            style={{
              marginBottom: '20px',
              marginTop: '20px',
              width: '100%',
            }}
            form={form}
            id="vert-modal-aprove-spot__form"
            scrollToFirstError
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
            onFinish={handleSubmit}
          >
            <Form.Item
              name="description"
              rules={[yupSync]}
              validateTrigger="onBlur"
            >
              <Input.TextArea
                className="modal-text-area"
                placeholder="* Deixe seu comentário"
              />
            </Form.Item>
          </Form>
        </div>
      </VertContainer>
    </VertModal>
  );
};

ModalApprove.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  submitApprove: PropTypes.func.isRequired,
  quote: PropTypes.object,
};

export default ModalApprove;
